import React from 'react'

import { useStyles } from './overlay.style'

export const Overlay = function ({ onClick }) {
  const classes = useStyles()

  return <div className={classes.overlay} onClick={onClick}></div>
}
